import { render, staticRenderFns } from "./AuthorPassageSelect.vue?vue&type=template&id=1d818c42"
import script from "./AuthorPassageSelect.vue?vue&type=script&lang=ts"
export * from "./AuthorPassageSelect.vue?vue&type=script&lang=ts"
import style0 from "./AuthorPassageSelect.vue?vue&type=style&index=0&id=1d818c42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports